module.exports = __webpack_public_path__ + "img/screen4.7dda2f02.png";